import { Grid, H, P } from '@farewill/ui'
import { BORDER, COLOR, GTR } from '@farewill/ui/tokens'
import styled from 'styled-components'
import { useQueryClient } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import ENV from 'config/environment'

import SelectInput from 'components/form/select-input'
import Label from 'components/styled/label'
import { AdminUser } from 'lib/models/admin-user'
import { formatAdminUserOptions } from 'utils/helpers'
import { updateProbateCase } from 'state/actions'
import { ProbateCase } from 'lib/models/probate-case'
import { noop } from 'lib/functions/noop'

const SraNumberBox = styled.div`
  background: ${COLOR.GREY.LIGHT};
  border-radius: ${BORDER.RADIUS.S};
  padding: ${GTR.S};
`

const CaseSupervisor = () => {
  const dispatch = useDispatch()
  const probateCase = useSelector(
    (state: { probateCase: ProbateCase }) => state.probateCase
  )
  const cache = useQueryClient()
  const adminUsers = cache.getQueryData('adminUsers') as AdminUser[]
  const owners = ENV.PROBATE_OWNERS_GROUP
    ? adminUsers.filter((u) =>
        u.attributes.microsoftGroups.includes(ENV.PROBATE_OWNERS_GROUP)
      )
    : adminUsers
  const supervisors = owners.filter((u) => u.attributes.probateSraNumber)
  const supervisorOptions = formatAdminUserOptions(supervisors)

  const selectedSupervisor = supervisors.find(
    (u) => u.id === probateCase.attributes.supervisorAdminUserId
  )

  const handleSupervisorChange = (supervisorId: number) => {
    if (!supervisorId) return
    dispatch(
      updateProbateCase(probateCase.id, {
        supervisorAdminUserId: supervisorId,
      })
    )
  }

  return (
    <Formik
      initialValues={{
        supervisorAdminUserId: probateCase.attributes.supervisorAdminUserId,
      }}
      validationSchema={Yup.object().shape({
        supervisorAdminUserId: Yup.number().nullable(),
      })}
      onSubmit={noop}
      enableReinitialize
    >
      <Form>
        <H size="XS">Case Supervisor</H>
        <P color={COLOR.GREY.DARK}>
          This is the person who is legally responsible for the case.
        </P>
        <Grid>
          <Grid.Item span={6}>
            <SelectInput
              label="Senior case manager"
              name="supervisorAdminUserId"
              options={supervisorOptions}
              handleSave={({ value }) =>
                handleSupervisorChange(value as number)
              }
              isClearable
            />
          </Grid.Item>
          <Grid.Item span={6}>
            <Label $error={false}>SRA number</Label>
            <SraNumberBox>
              {selectedSupervisor?.attributes.probateSraNumber || '—'}
            </SraNumberBox>
          </Grid.Item>
        </Grid>
      </Form>
    </Formik>
  )
}

export default CaseSupervisor
